import { useState, useEffect } from 'react';
  const perms = detectPerms();
import { useNavigate } from 'react-router-dom';
import { Plus, Trash2, Eye, Search, FileText, Loader2, AlertCircle, X, Filter, Layers, RotateCcw, CheckSquare, Square, ChevronRight, ChevronLeft, Users } from 'lucide-react';
import axios from 'axios';
import { detectPerms } from '../../permissions';
import { ProductAutocomplete } from './forms/ProductAutocomplete';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const DeliveryChallans = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [productMap, setProductMap] = useState({});
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [error, setError] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [fCustomerId, setFCustomerId] = useState('');
  const [fCompany, setFCompany] = useState('');
  const [fCompanyInput, setFCompanyInput] = useState('');
  const [showCompanySuggest, setShowCompanySuggest] = useState(false);
  const [fStatus, setFStatus] = useState('');
  const [fDateFrom, setFDateFrom] = useState('');
  const [fDateTo, setFDateTo] = useState('');
  const [fActivePreset, setFActivePreset] = useState('');
  const [fDueFrom, setFDueFrom] = useState('');
  const [fDueTo, setFDueTo] = useState('');
  const [fDuePreset, setFDuePreset] = useState('');
  const [applied, setApplied] = useState({ customerId: '', company: '', status: '', dateFrom: '', dateTo: '', dueFrom: '', dueTo: '' });

  // Bulk modal state
  const [bulkMode, setBulkMode] = useState(null); // 'sale' | 'return'
  const [bulkStep, setBulkStep] = useState(1);
  const [bulkCustomerId, setBulkCustomerId] = useState('');
  const [bulkSelected, setBulkSelected] = useState([]);
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  const [bulkError, setBulkError] = useState('');
  // Step 3 (Convert review) state — per selected DC
  const [bulkDcItems, setBulkDcItems] = useState({}); // { [dcId]: items[] }
  const [bulkItemActions, setBulkItemActions] = useState({}); // { 'dcId::itemId': 'sale'|'return' }
  const [bulkQtyActions, setBulkQtyActions] = useState({}); // { 'dcId::lineIndex': { sale, return } }

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try { setLoading(true);
      const [res, prodsRes, cRes] = await Promise.all([axios.get(`${BACKEND_URL}/api/delivery-challans`, getAuthHeaders()), axios.get(`${BACKEND_URL}/api/products`, getAuthHeaders()), axios.get(`${BACKEND_URL}/api/customers`, getAuthHeaders())]);
      setItems(res.data); setCustomers(cRes.data || []);
      const map = {}; (prodsRes.data || []).forEach(p => { map[p.id] = p.name; }); setProductMap(map);
    } catch (err) { setError('Failed to fetch delivery challans'); } finally { setLoading(false); }
  };
  const companyNames = [...new Set(items.map(i => i.company_name).filter(Boolean))].sort();
  const companySuggestions = fCompanyInput.trim() ? companyNames.filter(n => n.toLowerCase().includes(fCompanyInput.toLowerCase())) : companyNames.slice(0, 8);

  function calcPreset(preset) {
    const now = new Date(); let fd = '', td = '';
    const pad = n => String(n).padStart(2, '0');
    const fmt = d => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
    if (preset === 'this_month') { fd = fmt(new Date(now.getFullYear(), now.getMonth(), 1)); td = fmt(now); }
    else if (preset === 'last_month') { fd = fmt(new Date(now.getFullYear(), now.getMonth()-1, 1)); td = fmt(new Date(now.getFullYear(), now.getMonth(), 0)); }
    else if (preset === 'this_quarter') { const qs = Math.floor(now.getMonth()/3)*3; fd = fmt(new Date(now.getFullYear(), qs, 1)); td = fmt(now); }
    else if (preset === 'last_quarter') { const qs = Math.floor(now.getMonth()/3)*3-3; const y = qs<0?now.getFullYear()-1:now.getFullYear(); const qss=((qs%12)+12)%12; fd=fmt(new Date(y,qss,1)); td=fmt(new Date(y,qss+3,0)); }
    else if (preset === 'this_year') { fd = fmt(new Date(now.getFullYear(), 0, 1)); td = fmt(now); }
    else if (preset === 'last_year') { fd = fmt(new Date(now.getFullYear()-1, 0, 1)); td = fmt(new Date(now.getFullYear()-1, 11, 31)); }
    return { fd, td };
  }
  const applyPreset = (preset) => { const { fd, td } = calcPreset(preset); setFActivePreset(preset); setFDateFrom(fd); setFDateTo(td); };
  const applyDuePreset = (preset) => { const { fd, td } = calcPreset(preset); setFDuePreset(preset); setFDueFrom(fd); setFDueTo(td); };
  const applyFilters = () => setApplied({ customerId: fCustomerId, company: fCompany, status: fStatus, dateFrom: fDateFrom, dateTo: fDateTo, dueFrom: fDueFrom, dueTo: fDueTo });
  const clearFilters = () => { setFCustomerId(''); setFCompany(''); setFCompanyInput(''); setFStatus(''); setFDateFrom(''); setFDateTo(''); setFActivePreset(''); setFDueFrom(''); setFDueTo(''); setFDuePreset(''); setApplied({ customerId: '', company: '', status: '', dateFrom: '', dateTo: '', dueFrom: '', dueTo: '' }); };
  const hasFilters = applied.customerId || applied.company || applied.status || applied.dateFrom || applied.dateTo || applied.dueFrom || applied.dueTo;

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/delivery-challans/${id}`, getAuthHeaders());
      setDeleteConfirm(null); fetchItems();
    } catch (err) { setError('Failed to delete delivery challan'); }
  };

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';

  const filtered = (() => {
    let r = items.filter(i => (i.challan_number || '').toLowerCase().includes(searchQuery.toLowerCase()) || (i.customer_name || '').toLowerCase().includes(searchQuery.toLowerCase()));
    if (applied.customerId) r = r.filter(i => i.customer_id === applied.customerId);
    if (applied.company) r = r.filter(i => i.company_name === applied.company);
    if (applied.status === 'converted') r = r.filter(i => { const s = i.status || 'Open'; return s === 'Converted' || s === 'Partially Converted'; });
    if (applied.status === 'non_converted') r = r.filter(i => { const s = i.status || 'Open'; return s !== 'Converted' && s !== 'Partially Converted'; });
    if (applied.dateFrom) r = r.filter(i => { const d = (i.challan_date || i.created_at || '').split('T')[0]; return d >= applied.dateFrom; });
    if (applied.dateTo) r = r.filter(i => { const d = (i.challan_date || i.created_at || '').split('T')[0]; return d <= applied.dateTo; });
    if (applied.dueFrom) r = r.filter(i => i.due_date && i.due_date.split('T')[0] >= applied.dueFrom);
    if (applied.dueTo) r = r.filter(i => i.due_date && i.due_date.split('T')[0] <= applied.dueTo);
    return r;
  })();

  // ── Bulk helpers ─────────────────────────────────────────────────────────────

  const openBulkModal = (mode) => {
    setBulkMode(mode);
    setBulkStep(1);
    setBulkCustomerId('');
    setBulkSelected([]);
    setBulkError('');
    setBulkDcItems({});
    setBulkItemActions({});
    setBulkQtyActions({});
  };

  const closeBulkModal = () => { setBulkMode(null); setBulkSubmitting(false); setBulkError(''); setBulkDcItems({}); setBulkItemActions({}); setBulkQtyActions({}); };

  // Challans eligible for this bulk mode
  const bulkChallans = (() => {
    if (!bulkCustomerId) return [];
    return items.filter(i => {
      if (i.customer_id !== bulkCustomerId) return false;
      const s = i.status || 'Open';
      if (bulkMode === 'sale') {
        // Only Open challans (not yet converted to sale)
        return !['Converted', 'Partially Converted', 'Returned'].includes(s);
      } else {
        // Only challans already converted to sale
        return (s === 'Converted' || s === 'Partially Converted') && (i.sale_invoice_ids || []).length > 0;
      }
    });
  })();

  const toggleSelect = (id) => {
    setBulkSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const toggleAll = () => {
    if (bulkSelected.length === bulkChallans.length) setBulkSelected([]);
    else setBulkSelected(bulkChallans.map(c => c.id));
  };

  const buildConvertItems = (dc, action) => {
    const result = [];
    for (const li of dc.line_items || []) {
      if (!li.product_id) continue;
      const assignedIds = li.assigned_item_ids || [];
      if (assignedIds.length > 0) {
        assignedIds.forEach(iid => result.push({ product_id: li.product_id, item_id: iid, action }));
      } else {
        const qty = parseInt(li.quantity) || 0;
        if (qty > 0) result.push({ product_id: li.product_id, quantity: qty, action });
      }
    }
    return result;
  };

  const mergeSalePrefills = (prefills) => {
    const last = prefills[prefills.length - 1];
    const lineMap = {};
    for (const pf of prefills) {
      for (const li of pf.line_items || []) {
        const pid = li.product_id;
        if (lineMap[pid]) {
          lineMap[pid].quantity = (lineMap[pid].quantity || 0) + (li.quantity || 0);
          lineMap[pid].sold_item_ids = [...(lineMap[pid].sold_item_ids || []), ...(li.sold_item_ids || [])];
          lineMap[pid].total_amount = (lineMap[pid].total_amount || 0) + (li.total_amount || 0);
          lineMap[pid].tax_amount = (lineMap[pid].tax_amount || 0) + (li.tax_amount || 0);
        } else {
          lineMap[pid] = { ...li };
        }
      }
    }
    return {
      source_dc_id: prefills.map(p => p.source_dc_id).filter(Boolean).join(','),
      customer_id: last.customer_id,
      company_id: last.company_id,
      state_of_supply: last.state_of_supply,
      description: `Bulk conversion from ${prefills.length} challan(s)`,
      line_items: Object.values(lineMap),
    };
  };

  const mergeReturnPrefill = (selectedDcs, results) => {
    const last = selectedDcs[selectedDcs.length - 1];
    const lineMap = {};
    for (const dc of selectedDcs) {
      for (const li of dc.line_items || []) {
        if (!li.product_id) continue;
        const pid = li.product_id;
        const qty = parseInt(li.quantity) || 0;
        if (lineMap[pid]) {
          lineMap[pid].quantity = (lineMap[pid].quantity || 0) + qty;
          lineMap[pid].total_amount = (lineMap[pid].total_amount || 0) + (li.total_amount || 0);
        } else {
          lineMap[pid] = { product_id: pid, quantity: qty, unit_id: li.unit_id || '', price_per_unit: li.price_per_unit || '', discount_percentage: li.discount_percentage || 0, discount_amount: li.discount_amount || 0, tax_id: li.tax_id || '', tax_amount: li.tax_amount || 0, total_amount: li.total_amount || 0, description: li.description || '' };
        }
      }
    }
    return {
      customer_id: last.customer_id,
      company_id: last.company_id,
      state_of_supply: last.state_of_supply,
      description: `Bulk return from ${selectedDcs.length} challan(s)`,
      line_items: Object.values(lineMap),
    };
  };

  const buildConvertItemsForDc = (dcId, dcItemsList) => {
    const result = [];
    (dcItemsList || []).forEach(group => {
      if (group.quantity_based) {
        const q = bulkQtyActions[`${dcId}::${group.line_index}`] || { sale: 0, return: 0 };
        if (q.sale > 0) result.push({ product_id: group.product_id, quantity: q.sale, action: 'sale' });
        if (q.return > 0) result.push({ product_id: group.product_id, quantity: q.return, action: 'return' });
      } else {
        (group.item_ids || []).forEach(it => {
          if (it.status === 'assigned_to_dc') {
            const act = bulkItemActions[`${dcId}::${it.item_id}`];
            if (act) result.push({ product_id: group.product_id, item_id: it.item_id, action: act });
          }
        });
      }
    });
    return result;
  };

  const loadBulkDcItemsAndAdvance = async () => {
    if (!bulkSelected.length) { setBulkError('Please select at least one challan'); return; }
    setBulkSubmitting(true);
    setBulkError('');
    try {
      const selectedDcs = items.filter(i => bulkSelected.includes(i.id));
      const results = await Promise.all(
        selectedDcs.map(dc =>
          axios.get(`${BACKEND_URL}/api/delivery-challans/${dc.id}/items`, getAuthHeaders())
            .then(r => ({ dcId: dc.id, items: r.data }))
        )
      );
      const map = {};
      const actions = {};
      const qty = {};
      results.forEach(({ dcId, items: dcItemsList }) => {
        map[dcId] = dcItemsList;
        (dcItemsList || []).forEach(group => {
          if (group.quantity_based) {
            const q = parseFloat(group.quantity) || 0;
            qty[`${dcId}::${group.line_index}`] = bulkMode === 'sale'
              ? { sale: q, return: 0 }
              : { sale: 0, return: q };
          } else {
            (group.item_ids || []).forEach(it => {
              if (it.status === 'assigned_to_dc') actions[`${dcId}::${it.item_id}`] = bulkMode;
            });
          }
        });
      });
      setBulkDcItems(map);
      setBulkItemActions(actions);
      setBulkQtyActions(qty);
      setBulkStep(3);
    } catch (err) {
      setBulkError(err.response?.data?.detail || 'Failed to load challan items');
    } finally { setBulkSubmitting(false); }
  };

  const toggleBulkAction = (dcId, itemId) => {
    setBulkItemActions(prev => ({
      ...prev,
      [`${dcId}::${itemId}`]: prev[`${dcId}::${itemId}`] === 'sale' ? 'return' : 'sale'
    }));
  };

  const updateBulkQtyAction = (dcId, lineIndex, field, value, max) => {
    const v = Math.max(0, Math.min(parseFloat(value) || 0, max));
    setBulkQtyActions(prev => {
      const key = `${dcId}::${lineIndex}`;
      const cur = prev[key] || { sale: 0, return: 0 };
      const other = field === 'sale' ? 'return' : 'sale';
      const otherMax = Math.max(0, max - v);
      return {
        ...prev,
        [key]: { [field]: v, [other]: Math.min(cur[other], otherMax) }
      };
    });
  };

  const handleBulkCreate = async () => {
    if (!bulkSelected.length) { setBulkError('Please select at least one challan'); return; }
    setBulkSubmitting(true);
    setBulkError('');
    const selectedDcs = items.filter(i => bulkSelected.includes(i.id));
    try {
      const prefills = [];
      let anyConverted = false;
      for (const dc of selectedDcs) {
        const dcItemsList = bulkDcItems[dc.id] || [];
        const convertItems = buildConvertItemsForDc(dc.id, dcItemsList);
        if (!convertItems.length) continue;
        const res = await axios.post(`${BACKEND_URL}/api/delivery-challans/${dc.id}/convert`, { items: convertItems }, getAuthHeaders());
        anyConverted = true;
        if (res.data.has_sale && res.data.sale_prefill) prefills.push(res.data.sale_prefill);
      }
      if (!anyConverted) { setBulkError('No items selected for conversion'); setBulkSubmitting(false); return; }
      if (bulkMode === 'sale') {
        if (!prefills.length) { setBulkError('No items available to convert to sale'); setBulkSubmitting(false); return; }
        const merged = mergeSalePrefills(prefills);
        sessionStorage.setItem('dc_sale_prefill', JSON.stringify(merged));
        navigate('/admin/sale/invoices/new?from_dc=bulk');
      } else {
        const returnPrefill = mergeReturnPrefill(selectedDcs, []);
        sessionStorage.setItem('dc_return_prefill', JSON.stringify(returnPrefill));
        navigate('/admin/sale/credit-notes/new?from_dc=bulk');
      }
    } catch (err) {
      setBulkError(err.response?.data?.detail || 'Failed to process challans');
      setBulkSubmitting(false);
    }
  };

  const bulkSelectedTotal = items.filter(i => bulkSelected.includes(i.id)).reduce((s, i) => s + (i.total || 0), 0);
  const selectedCustomerName = customers.find(c => c.id === bulkCustomerId)?.name || '';

  return (
    <div data-testid="delivery-challans-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 uppercase tracking-tight">Delivery Challans</h1>
          <p className="text-slate-600 mt-1">Manage delivery challans</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {perms.canAdd && (
            <>
              <button onClick={() => openBulkModal('return')} data-testid="bulk-return-btn"
                className="inline-flex items-center gap-2 bg-slate-600 text-white font-bold tracking-wider uppercase px-4 py-2.5 rounded-none hover:bg-slate-700 transition-colors text-sm">
                <RotateCcw className="h-4 w-4" /> Bulk Return
              </button>
              <button onClick={() => openBulkModal('sale')} data-testid="bulk-sale-btn"
                className="inline-flex items-center gap-2 bg-blue-600 text-white font-bold tracking-wider uppercase px-4 py-2.5 rounded-none hover:bg-blue-700 transition-colors text-sm">
                <Layers className="h-4 w-4" /> Bulk Sale
              </button>
              <button onClick={() => navigate('/admin/sale/delivery-challan/new')} data-testid="create-challan-btn"
                className="inline-flex items-center gap-2 bg-orange-500 text-white font-bold tracking-wider uppercase px-6 py-3 rounded-none hover:bg-orange-600 transition-colors">
                <Plus className="h-5 w-5" /> Create Delivery Challan
              </button>
            </>
          )}
        </div>
      </div>

      <div className="bg-white rounded-sm border border-slate-200 p-4 mb-4">
        <div className="relative"><Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" /><input type="text" placeholder="Search by challan number or customer..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} data-testid="search-input" className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-sm focus:border-orange-500 focus:outline-none" /></div>
      </div>
      <div className="bg-white rounded-sm border border-slate-200 p-4 mb-6">
        <div className="flex items-center gap-2 mb-3"><Filter className="h-4 w-4 text-slate-500" /><span className="text-sm font-semibold text-slate-700 uppercase tracking-wider">Filters</span>{hasFilters && <button onClick={clearFilters} data-testid="clear-filters-btn" className="ml-auto text-xs text-red-500 hover:text-red-600 font-medium">Clear All</button>}</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 items-end">
          <div><label className="block text-xs font-medium text-slate-500 uppercase mb-1">Customer</label><ProductAutocomplete value={fCustomerId} onChange={setFCustomerId} products={customers} testId="filter-customer" placeholder="Type customer..." /></div>
          <div>
            <label className="block text-xs font-medium text-slate-500 uppercase mb-1">Company</label>
            <div className="relative">
              <input type="text" value={fCompanyInput} onChange={e => { setFCompanyInput(e.target.value); setFCompany(''); setShowCompanySuggest(true); }} onFocus={() => setShowCompanySuggest(true)} onBlur={() => setTimeout(() => setShowCompanySuggest(false), 150)} placeholder="Type company..." data-testid="filter-company-input" className="w-full px-3 py-2 border border-slate-200 rounded-sm text-sm focus:border-orange-500 focus:outline-none" />
              {fCompanyInput && <button onClick={() => { setFCompany(''); setFCompanyInput(''); }} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"><X className="h-4 w-4" /></button>}
              {showCompanySuggest && companySuggestions.length > 0 && (
                <div className="absolute z-20 top-full left-0 right-0 mt-0.5 bg-white border border-slate-200 rounded-sm shadow-lg max-h-44 overflow-auto">
                  {companySuggestions.map(name => (
                    <button key={name} onMouseDown={() => { setFCompany(name); setFCompanyInput(name); setShowCompanySuggest(false); }} className={`w-full text-left px-3 py-2 text-sm hover:bg-orange-50 hover:text-orange-700 ${fCompany === name ? 'bg-orange-50 text-orange-700 font-medium' : 'text-slate-700'}`}>{name}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div><label className="block text-xs font-medium text-slate-500 uppercase mb-1">Status</label><select value={fStatus} onChange={e => setFStatus(e.target.value)} data-testid="filter-status" className="w-full px-3 py-2 border border-slate-200 rounded-sm text-sm focus:border-orange-500 focus:outline-none bg-white"><option value="">All</option><option value="converted">Converted</option><option value="non_converted">Non-Converted</option></select></div>
          <div><button onClick={applyFilters} data-testid="apply-filters-btn" className="w-full px-4 py-2 bg-orange-500 text-white text-sm font-bold uppercase tracking-wider rounded-sm hover:bg-orange-600 transition-colors">Apply</button></div>
        </div>
        <div className="mt-3 pt-3 border-t border-slate-100">
          <p className="text-xs font-semibold text-slate-500 uppercase mb-2">Challan Date</p>
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex flex-wrap gap-1.5">
              {[{ key: 'this_month', label: 'This Month' }, { key: 'last_month', label: 'Last Month' }, { key: 'this_quarter', label: 'This Quarter' }, { key: 'last_quarter', label: 'Last Quarter' }, { key: 'this_year', label: 'This Year' }, { key: 'last_year', label: 'Last Year' }].map(p => (
                <button key={p.key} onClick={() => applyPreset(p.key)} data-testid={`preset-${p.key}`} className={`px-3 py-1.5 text-xs font-semibold rounded-sm border transition-colors ${fActivePreset === p.key ? 'bg-orange-500 text-white border-orange-500' : 'border-slate-200 text-slate-600 hover:border-orange-400 hover:text-orange-600'}`}>{p.label}</button>
              ))}
            </div>
            <div className="h-5 w-px bg-slate-200 hidden md:block" />
            <div className="flex items-center gap-2 flex-wrap">
              <div className="flex items-center gap-1.5"><label className="text-xs text-slate-500 font-medium whitespace-nowrap">From</label><input type="date" value={fDateFrom} onChange={e => { setFDateFrom(e.target.value); setFActivePreset(''); }} data-testid="date-from" className="px-2 py-1.5 border border-slate-200 rounded-sm text-xs focus:border-orange-500 focus:outline-none" /></div>
              <div className="flex items-center gap-1.5"><label className="text-xs text-slate-500 font-medium">To</label><input type="date" value={fDateTo} onChange={e => { setFDateTo(e.target.value); setFActivePreset(''); }} data-testid="date-to" className="px-2 py-1.5 border border-slate-200 rounded-sm text-xs focus:border-orange-500 focus:outline-none" /></div>
            </div>
          </div>
        </div>
        <div className="mt-3 pt-3 border-t border-slate-100">
          <p className="text-xs font-semibold text-slate-500 uppercase mb-2">Due Date</p>
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex flex-wrap gap-1.5">
              {[{ key: 'this_month', label: 'This Month' }, { key: 'last_month', label: 'Last Month' }, { key: 'this_quarter', label: 'This Quarter' }, { key: 'last_quarter', label: 'Last Quarter' }, { key: 'this_year', label: 'This Year' }, { key: 'last_year', label: 'Last Year' }].map(p => (
                <button key={`due_${p.key}`} onClick={() => applyDuePreset(p.key)} data-testid={`due-preset-${p.key}`} className={`px-3 py-1.5 text-xs font-semibold rounded-sm border transition-colors ${fDuePreset === p.key ? 'bg-orange-500 text-white border-orange-500' : 'border-slate-200 text-slate-600 hover:border-orange-400 hover:text-orange-600'}`}>{p.label}</button>
              ))}
            </div>
            <div className="h-5 w-px bg-slate-200 hidden md:block" />
            <div className="flex items-center gap-2 flex-wrap">
              <div className="flex items-center gap-1.5"><label className="text-xs text-slate-500 font-medium whitespace-nowrap">From</label><input type="date" value={fDueFrom} onChange={e => { setFDueFrom(e.target.value); setFDuePreset(''); }} data-testid="due-from" className="px-2 py-1.5 border border-slate-200 rounded-sm text-xs focus:border-orange-500 focus:outline-none" /></div>
              <div className="flex items-center gap-1.5"><label className="text-xs text-slate-500 font-medium">To</label><input type="date" value={fDueTo} onChange={e => { setFDueTo(e.target.value); setFDuePreset(''); }} data-testid="due-to" className="px-2 py-1.5 border border-slate-200 rounded-sm text-xs focus:border-orange-500 focus:outline-none" /></div>
            </div>
          </div>
        </div>
      </div>

      {error && (
        <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-sm mb-6">
          <AlertCircle className="h-5 w-5" /><span>{error}</span>
          <button onClick={() => setError('')} className="ml-auto"><X className="h-4 w-4" /></button>
        </div>
      )}

      <div className="bg-white rounded-sm border border-slate-200">
        {loading ? (
          <div className="flex items-center justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-orange-500" /></div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-16" data-testid="empty-state">
            <FileText className="h-16 w-16 mx-auto mb-4 text-slate-300" />
            <h3 className="text-xl font-semibold text-slate-700 mb-2">No delivery challans yet</h3>
            <p className="text-slate-500 mb-6">Create your first delivery challan</p>
            <button onClick={() => navigate('/admin/sale/delivery-challan/new')}
              className="inline-flex items-center gap-2 bg-orange-500 text-white font-bold tracking-wider uppercase px-6 py-3 rounded-none hover:bg-orange-600 transition-colors">
              <Plus className="h-5 w-5" /> Create First Challan
            </button>
          </div>
        ) : (
          <>
            <div className="hidden md:grid grid-cols-9 gap-4 px-6 py-4 border-b border-slate-200 bg-slate-50">
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Date</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Challan No.</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Customer</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Company</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Total Units</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Due Date</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Total</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Status</div>
              <div className="font-semibold text-slate-700 text-sm uppercase tracking-wider">Actions</div>
            </div>
            {filtered.map((item) => {
              const status = item.status || 'Open';
              const saleIds = item.sale_invoice_ids || [];
              const isConverted = status === 'Converted' || status === 'Partially Converted';
              const isReturned = status === 'Returned';
              const totalUnits = (item.line_items || []).reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
              const styles = isConverted ? 'bg-green-100 text-green-700 hover:bg-green-200' : (isReturned ? 'bg-slate-200 text-slate-700' : 'bg-slate-100 text-slate-600');
              return (
              <div key={item.id} className="border-b border-slate-100 hover:bg-slate-50">
                <div data-testid={`challan-row-${item.id}`}
                  className="grid grid-cols-1 md:grid-cols-9 gap-4 px-6 pt-4 items-center">
                  <div className="text-slate-600 text-sm">{formatDate(item.challan_date || item.created_at)}</div>
                  <div className="font-mono font-medium text-slate-900">{item.challan_number || '-'}</div>
                  <div className="text-slate-700 text-sm">{item.customer_name || '-'}</div>
                  <div className="text-slate-700 text-sm">{item.company_name || '-'}</div>
                  <div className="font-medium text-slate-900" data-testid={`challan-units-${item.id}`}>
                    {totalUnits.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                  </div>
                  <div className="text-slate-600 text-sm">{formatDate(item.due_date)}</div>
                  <div className="font-medium text-slate-900">₹{(item.total || 0).toLocaleString()}</div>
                  <div className="text-sm">
                    {isConverted && saleIds.length > 0 ? (
                      <button
                        onClick={(e) => { e.stopPropagation(); navigate(`/admin/sale/invoices/${saleIds[saleIds.length - 1]}`); }}
                        data-testid={`converted-link-${item.id}`}
                        title={saleIds.length > 1 ? `${saleIds.length} sale invoice(s) — click to view latest` : 'View sale invoice'}
                        className={`inline-flex items-center px-2 py-1 text-xs font-bold uppercase rounded transition-colors ${styles}`}
                      >
                        {status}{saleIds.length > 1 ? ` (${saleIds.length})` : ''}
                      </button>
                    ) : (
                      <span className={`inline-flex items-center px-2 py-1 text-xs font-bold uppercase rounded ${styles}`} data-testid={`status-badge-${item.id}`}>
                        {status}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    <button onClick={() => navigate(`/admin/sale/delivery-challan/${item.id}`)} data-testid={`view-btn-${item.id}`}
                      className="p-2 text-slate-600 hover:text-orange-500 hover:bg-orange-50 rounded transition-colors">
                      <Eye className="h-4 w-4" />
                    </button>
                    {perms.canDelete && (
                    <button onClick={() => setDeleteConfirm(item.id)} data-testid={`delete-btn-${item.id}`}
                      className="p-2 text-slate-600 hover:text-red-500 hover:bg-red-50 rounded transition-colors">
                      <Trash2 className="h-4 w-4" />
                    </button>
                    )}
                  </div>
                </div>
              </div>
              );
            })}
          </>
        )}
      </div>

      {deleteConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-sm p-6 max-w-md w-full">
            <h3 className="text-xl font-bold text-slate-900 mb-4">Confirm Delete</h3>
            <p className="text-slate-600 mb-6">Are you sure you want to delete this delivery challan?</p>
            <div className="flex gap-3 justify-end">
              <button onClick={() => setDeleteConfirm(null)} className="px-4 py-2 border border-slate-200 text-slate-700 rounded-sm hover:bg-slate-50">Cancel</button>
              {perms.canDelete && (
              <button onClick={() => handleDelete(deleteConfirm)} data-testid="confirm-delete-btn" className="px-4 py-2 bg-red-500 text-white rounded-sm hover:bg-red-600">Delete</button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Bulk Modal ─────────────────────────────────────────────────────── */}
      {bulkMode && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-sm w-full max-w-3xl flex flex-col" style={{ maxHeight: '90vh' }}>

            {/* Header */}
            <div className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200">
              <div className="flex items-center gap-3">
                {bulkMode === 'sale'
                  ? <Layers className="h-5 w-5 text-blue-600" />
                  : <RotateCcw className="h-5 w-5 text-slate-600" />}
                <h2 className="text-xl font-bold text-slate-900 uppercase tracking-tight">
                  {bulkMode === 'sale' ? 'Create Bulk Sale' : 'Create Bulk Return'}
                </h2>
                <span className="text-xs font-medium text-slate-400 bg-slate-100 px-2 py-0.5 rounded">Step {bulkStep} of 3</span>
              </div>
              <button onClick={closeBulkModal} className="p-2 text-slate-400 hover:text-slate-600"><X className="h-5 w-5" /></button>
            </div>

            {bulkError && (
              <div className="flex-shrink-0 flex items-center gap-2 bg-red-50 border-b border-red-200 text-red-700 px-6 py-3 text-sm">
                <AlertCircle className="h-4 w-4 flex-shrink-0" />{bulkError}
              </div>
            )}

            {/* Step 1: Select Customer */}
            {bulkStep === 1 && (
              <div className="flex-1 overflow-y-auto p-6">
                <div className="flex items-center gap-2 mb-5 text-slate-600">
                  <Users className="h-5 w-5" />
                  <p className="text-sm">
                    {bulkMode === 'sale'
                      ? 'Select a customer to see their open (unconverted) delivery challans.'
                      : 'Select a customer to see their challans already converted to sale (eligible for return).'}
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 uppercase tracking-wider mb-2">Customer</label>
                  <ProductAutocomplete
                    value={bulkCustomerId}
                    onChange={setBulkCustomerId}
                    products={customers}
                    testId="bulk-customer-select"
                    placeholder="Type customer name..."
                  />
                </div>
                {bulkCustomerId && (
                  <div className="mt-4 p-3 bg-slate-50 rounded-sm border border-slate-200 text-sm text-slate-600">
                    {(() => {
                      const count = items.filter(i => {
                        if (i.customer_id !== bulkCustomerId) return false;
                        const s = i.status || 'Open';
                        return bulkMode === 'sale'
                          ? !['Converted', 'Partially Converted', 'Returned'].includes(s)
                          : (s === 'Converted' || s === 'Partially Converted') && (i.sale_invoice_ids || []).length > 0;
                      }).length;
                      return count > 0
                        ? <span className="text-green-700 font-medium">{count} eligible challan{count !== 1 ? 's' : ''} found</span>
                        : <span className="text-slate-500">No eligible challans for this customer</span>;
                    })()}
                  </div>
                )}
              </div>
            )}

            {/* Step 2: Multi-select challans */}
            {bulkStep === 2 && (
              <div className="flex-1 overflow-y-auto">
                {/* Select-all bar */}
                <div className="flex items-center justify-between px-6 py-3 border-b border-slate-100 bg-slate-50">
                  <button onClick={toggleAll} className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-orange-600 transition-colors">
                    {bulkSelected.length === bulkChallans.length && bulkChallans.length > 0
                      ? <CheckSquare className="h-4 w-4 text-orange-500" />
                      : <Square className="h-4 w-4" />}
                    {bulkSelected.length === bulkChallans.length ? 'Deselect All' : 'Select All'}
                  </button>
                  <span className="text-xs text-slate-500">{bulkSelected.length} of {bulkChallans.length} selected</span>
                </div>

                {bulkChallans.length === 0 ? (
                  <div className="text-center py-12 text-slate-500">
                    <FileText className="h-10 w-10 mx-auto mb-3 text-slate-300" />
                    <p className="text-sm">No eligible challans for this customer</p>
                  </div>
                ) : (
                  <div className="divide-y divide-slate-100">
                    {bulkChallans.map(dc => {
                      const sel = bulkSelected.includes(dc.id);
                      const lineCount = (dc.line_items || []).filter(li => li.product_id).length;
                      return (
                        <label key={dc.id} className={`flex items-center gap-4 px-6 py-4 cursor-pointer transition-colors ${sel ? 'bg-orange-50' : 'hover:bg-slate-50'}`}>
                          <input type="checkbox" checked={sel} onChange={() => toggleSelect(dc.id)} className="w-4 h-4 accent-orange-500" />
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                              <span className="font-mono font-bold text-slate-900 text-sm" data-testid={`bulk-challan-no-${dc.id}`}>{dc.challan_number || '-'}</span>
                              <span className="text-xs text-slate-400">{formatDate(dc.challan_date || dc.created_at)}</span>
                            </div>
                            <div className="text-xs text-slate-500 mt-0.5">{lineCount} product{lineCount !== 1 ? 's' : ''} &nbsp;·&nbsp; {dc.company_name || 'No company'}</div>
                          </div>
                          <div className="text-sm font-bold text-slate-900 flex-shrink-0">₹{(dc.total || 0).toLocaleString()}</div>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Step 3: Per-item Sale/Return review (matches DC detail modal) */}
            {bulkStep === 3 && (
              <div className="flex-1 overflow-y-auto p-6" data-testid="bulk-convert-review">
                <p className="text-sm text-slate-500 mb-4">
                  Toggle each item as <span className="font-semibold text-green-700">Sale</span> or <span className="font-semibold text-slate-600">Return</span>, or split quantities. Items default to <span className="font-semibold uppercase">{bulkMode}</span>.
                </p>
                {items.filter(i => bulkSelected.includes(i.id)).map(dc => {
                  const dcItemsList = bulkDcItems[dc.id] || [];
                  return (
                    <div key={dc.id} className="mb-6 border border-slate-200 rounded-sm" data-testid={`bulk-convert-dc-${dc.id}`}>
                      <div className="px-4 py-2.5 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
                        <span className="font-mono font-bold text-slate-900 text-sm">{dc.challan_number || '-'}</span>
                        <span className="text-xs text-slate-500">{dc.customer_name} &nbsp;·&nbsp; {dc.company_name || 'No company'}</span>
                      </div>
                      <div className="p-4">
                        {dcItemsList.length === 0 && (
                          <p className="text-sm text-slate-500 text-center py-3">No items to convert.</p>
                        )}
                        {dcItemsList.map((group, gIdx) => {
                          if (group.quantity_based) {
                            const q = bulkQtyActions[`${dc.id}::${group.line_index}`] || { sale: 0, return: 0 };
                            const maxQty = parseFloat(group.quantity) || 0;
                            const accounted = (parseFloat(q.sale) || 0) + (parseFloat(q.return) || 0);
                            const remaining = maxQty - accounted;
                            return (
                              <div key={gIdx} className="mb-4 last:mb-0">
                                <div className="flex items-center justify-between mb-2">
                                  <h3 className="text-sm font-bold text-slate-900">{group.product_name || productMap[group.product_id] || 'Product'}</h3>
                                  <span className="text-xs text-slate-500">Total Qty: <span className="font-bold text-slate-800">{maxQty}</span></span>
                                </div>
                                <div className="grid grid-cols-2 gap-3 px-4 py-3 border border-slate-200 rounded-sm bg-slate-50">
                                  <div>
                                    <label className="block text-[10px] font-bold uppercase text-green-700 mb-1">Sale Qty</label>
                                    <input type="number" min="0" max={maxQty} step="1" value={q.sale}
                                      onChange={(e) => updateBulkQtyAction(dc.id, group.line_index, 'sale', e.target.value, maxQty)}
                                      data-testid={`bulk-qty-sale-${dc.id}-${gIdx}`}
                                      className="w-full px-3 py-2 border border-green-200 rounded-sm text-sm font-bold text-green-700 focus:border-green-500 focus:outline-none bg-green-50" />
                                  </div>
                                  <div>
                                    <label className="block text-[10px] font-bold uppercase text-slate-600 mb-1">Return Qty</label>
                                    <input type="number" min="0" max={maxQty} step="1" value={q.return}
                                      onChange={(e) => updateBulkQtyAction(dc.id, group.line_index, 'return', e.target.value, maxQty)}
                                      data-testid={`bulk-qty-return-${dc.id}-${gIdx}`}
                                      className="w-full px-3 py-2 border border-slate-200 rounded-sm text-sm font-bold text-slate-700 focus:border-slate-500 focus:outline-none bg-white" />
                                  </div>
                                </div>
                                {remaining !== 0 && (
                                  <p className={`text-xs mt-1 ${remaining > 0 ? 'text-amber-600' : 'text-red-600'}`}>
                                    {remaining > 0 ? `${remaining} unit(s) not accounted for` : `Over by ${Math.abs(remaining)} unit(s)`}
                                  </p>
                                )}
                              </div>
                            );
                          }
                          const actionableItems = (group.item_ids || []).filter(it => it.status === 'assigned_to_dc');
                          if (!actionableItems.length) return null;
                          return (
                            <div key={gIdx} className="mb-4 last:mb-0">
                              <h3 className="text-sm font-bold text-slate-900 mb-2">{group.product_name || productMap[group.product_id] || 'Product'}</h3>
                              <div className="space-y-1.5">
                                {actionableItems.map(it => {
                                  const act = bulkItemActions[`${dc.id}::${it.item_id}`];
                                  return (
                                    <div key={it.item_id} className="flex items-center justify-between px-4 py-2.5 border border-slate-200 rounded-sm hover:bg-slate-50">
                                      <div>
                                        <span className="block font-mono text-sm text-slate-800">{it.item_id}</span>
                                        <span className="block text-xs text-slate-500">Asset ID: <span className="font-mono">{it.asset_id || '-'}</span></span>
                                      </div>
                                      <button type="button"
                                        onClick={() => toggleBulkAction(dc.id, it.item_id)}
                                        data-testid={`bulk-toggle-${dc.id}-${it.item_id}`}
                                        className={`px-4 py-1.5 text-xs font-bold uppercase rounded-sm transition-colors ${
                                          act === 'sale'
                                            ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                            : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
                                        }`}>
                                        {act === 'sale' ? 'Sale' : 'Return'}
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Footer */}
            <div className="flex-shrink-0 border-t border-slate-200 px-6 py-4 bg-white">
              {bulkStep === 2 && bulkSelected.length > 0 && (
                <div className="flex items-center gap-4 mb-3 text-sm">
                  <span className="text-slate-500">{bulkSelected.length} challan{bulkSelected.length !== 1 ? 's' : ''} selected</span>
                  <span className="text-slate-400">·</span>
                  <span className="font-bold text-slate-900">Total: ₹{bulkSelectedTotal.toLocaleString()}</span>
                </div>
              )}
              <div className="flex gap-3 justify-between">
                <button onClick={
                    bulkStep === 1 ? closeBulkModal
                    : bulkStep === 2 ? () => { setBulkStep(1); setBulkSelected([]); }
                    : () => setBulkStep(2)
                  }
                  disabled={bulkSubmitting}
                  className="inline-flex items-center gap-2 px-5 py-2 border border-slate-200 text-slate-700 rounded-sm hover:bg-slate-50 text-sm font-medium disabled:opacity-50">
                  {bulkStep === 1 ? 'Cancel' : <><ChevronLeft className="h-4 w-4" /> Back</>}
                </button>
                {bulkStep === 1 && (
                  <button
                    onClick={() => { if (!bulkCustomerId) { setBulkError('Please select a customer'); return; } setBulkError(''); setBulkSelected([]); setBulkStep(2); }}
                    className="inline-flex items-center gap-2 px-5 py-2 bg-orange-500 text-white rounded-sm hover:bg-orange-600 text-sm font-bold uppercase tracking-wider">
                    Next <ChevronRight className="h-4 w-4" />
                  </button>
                )}
                {bulkStep === 2 && (
                  <button
                    onClick={loadBulkDcItemsAndAdvance}
                    disabled={bulkSubmitting || !bulkSelected.length}
                    data-testid="bulk-next-review-btn"
                    className="inline-flex items-center gap-2 px-5 py-2 bg-orange-500 text-white rounded-sm hover:bg-orange-600 text-sm font-bold uppercase tracking-wider disabled:opacity-50">
                    {bulkSubmitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Next <ChevronRight className="h-4 w-4" /></>}
                  </button>
                )}
                {bulkStep === 3 && (
                  <button
                    onClick={handleBulkCreate}
                    disabled={bulkSubmitting}
                    data-testid="bulk-create-confirm-btn"
                    className={`inline-flex items-center gap-2 px-5 py-2 text-white rounded-sm text-sm font-bold uppercase tracking-wider disabled:opacity-50 ${
                      bulkMode === 'sale' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-slate-700 hover:bg-slate-800'
                    }`}>
                    {bulkSubmitting ? <Loader2 className="h-4 w-4 animate-spin" /> : (bulkMode === 'sale' ? <Layers className="h-4 w-4" /> : <RotateCcw className="h-4 w-4" />)}
                    {bulkSubmitting ? 'Processing…' : (bulkMode === 'sale' ? 'Confirm Bulk Sale' : 'Confirm Bulk Return')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
